import { all, call, put, take, takeLatest } from 'redux-saga/effects'
import { push } from 'connected-react-router'
import actionTypes from '../../actions/actionTypes'
import createApiCall, { apiURL } from '../../apis/wpApi/endpoints'
import authUser from '../../apis/wpApi/authUser'
import { OVERLAY_SPINNER } from '../../constants/overlayTypes'
import getRedirectPath from '../../functions/getRedirectPath'

function* watchTmdbSearch() {
    yield takeLatest(actionTypes.TMDB_SEARCH_REQUEST, function* ({ payload }) {
        try {
            const { query, year, language } = payload
            const token = authUser.getToken()
            const response = yield call(createApiCall, {
                url: apiURL.TMDB_SEARCH,
                method: 'GET',
                params: { query, ...(year && { year }), ...(language && { language }) },
                headerParams: { token }
            })
            yield put({ type: actionTypes.TMDB_SEARCH_SUCCESS, payload: { results: response.data } })
        } catch (e) {
            yield put({ type: actionTypes.TMDB_SEARCH_FAILURE, payload: { error: e.message } })
        }
    })
}

function* watchTmdbDetails() {
    yield takeLatest(actionTypes.TMDB_DETAILS_REQUEST, function* ({ payload }) {
        try {
            const { tmdbId, language } = payload
            const token = authUser.getToken()
            const response = yield call(createApiCall, {
                url: apiURL.TMDB_DETAILS + '/' + tmdbId,
                method: 'GET',
                params: { ...(language && { language }) },
                headerParams: { token }
            })
            yield put({ type: actionTypes.TMDB_DETAILS_SUCCESS, payload: { tmdbId, details: response.data } })
        } catch (e) {
            // silently ignore details fetch errors
        }
    })
}

function* watchTmdbMatch() {
    yield takeLatest(actionTypes.TMDB_MATCH_REQUEST, function* ({ payload }) {
        try {
            const { metaMoviePk, tmdbMoviePk, metaMovie, from, pmMovie, tmdbMovieData } = payload
            const token = authUser.getToken()
            yield put({ type: actionTypes.UI_GENERAL_REQUEST_OVERLAY_SET_REQUEST_TYPE, payload: { requestType: actionTypes.TMDB_MATCH_REQUEST } })
            yield put({ type: actionTypes.UI_GENERAL_REQUEST_OVERLAY_SET_OVERLAY_TYPE, payload: { overlayType: OVERLAY_SPINNER } })
            yield call(createApiCall, {
                url: apiURL.TMDB_MATCH,
                method: 'POST',
                data: { metaMoviePk, tmdbMoviePk, metaMovie, pmMovie: pmMovie || null },
                headerParams: { token }
            })
            yield put({
                type: actionTypes.TMDB_MATCH_SUCCESS,
                payload: { metaMoviePk, tmdbUuid: tmdbMoviePk, pmMovie: pmMovie || null, tmdbMovieData: tmdbMovieData || null, metaMovie: metaMovie || null }
            })
            yield put({ type: actionTypes.PROGRAM_GET_REQUEST, payload: { signal: false } })
            yield take([actionTypes.PROGRAM_GET_SUCCESS, actionTypes.PROGRAM_GET_ERROR])
            yield put({ type: actionTypes.UI_GENERAL_REQUEST_OVERLAY_RESET })
            yield put(push(getRedirectPath(from, { metaMoviePk })))
        } catch (e) {
            yield put({ type: actionTypes.TMDB_MATCH_FAILURE, payload: { error: e.message } })
            yield put({ type: actionTypes.UI_GENERAL_REQUEST_OVERLAY_RESET })
        }
    })
}

function* watchTmdbUnmatch() {
    yield takeLatest(actionTypes.TMDB_UNMATCH_REQUEST, function* ({ payload }) {
        try {
            const { metaMoviePk, from } = payload
            const token = authUser.getToken()
            yield call(createApiCall, {
                url: apiURL.TMDB_UNMATCH,
                method: 'POST',
                data: { metaMoviePk },
                headerParams: { token }
            })
            yield put({
                type: actionTypes.TMDB_UNMATCH_SUCCESS,
                payload: { metaMoviePk }
            })
            yield put(push(getRedirectPath(from)))
        } catch (e) {
            yield put({ type: actionTypes.TMDB_UNMATCH_FAILURE, payload: { error: e.message } })
        }
    })
}

export default function* tmdbSaga() {
    yield all([
        watchTmdbSearch(),
        watchTmdbDetails(),
        watchTmdbMatch(),
        watchTmdbUnmatch(),
    ])
}
